export default __webpack_public_path__ + "static/media/mTop_2.2985f002.bin";